import "../pages.scss"
import { ClientesState } from '../../context/clientes/ClientesState';
import Datatable from "./clientesTable/Datatable"

const ClientesPage = () => {
  return (
    <>
      <ClientesState>
        <Datatable />
      </ClientesState>
    </>
  )
}

export default ClientesPage